export const CustomNotification = {
	notificationInfoBackground: 'var(--epods--color-signal-info-bg)',
	notificationInfoText: 'var(--epods--color-signal-info-text)',

	notificationPositiveBackground: 'var(--epods--color-signal-success-bg)',
	notificationPositiveText: 'var(--epods--color-signal-success-text)',

	notificationWarningBackground: 'var(--epods--color-signal-warning-bg)',
	notificationWarningText: 'var(--epods--color-signal-warning-text)',

	notificationNegativeBackground: 'var(--epods--color-signal-error-bg)',
	notificationNegativeText: 'var(--epods--color-signal-error-text)',

	borderColorInfo: 'var(--epods--color-signal-info-border)',
	borderColorNegative: 'var(--epods--color-signal-error-border)',
	borderColorWarning: 'var(--epods--color-signal-warning-border)',
	borderColorPositive: 'var(--epods--color-signal-success-border)',

	notificationNeutralBackground: 'var(--epods--color-bg-forth-elevation)',
	notificationNeutralText: 'var(--epods--color-text-primary)',
	borderColorNeutral: 'var(--epods--color-border-light)',

	notificationBodyPaddingTopBottom: 'var(--epods--notification-body-padding-topBottom)',
	notificationBodyPaddingRight: 'var(--epods--notification-body-padding-right)',
	notificationBodyPaddingLeft: 'var(--epods--notification-body-padding-left)',
};
